module.exports = require("@splunk/visualization-context/GeoContext");